import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const pollList = createAsyncThunk('poll/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `poll`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'premise_id': data?.premise_id,
                'poll_start_date': data?.start_date,
                'poll_end_date': data?.end_date,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const pollDetails = createAsyncThunk('poll/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `poll/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addPoll = createAsyncThunk('poll/add', async (data) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'poll',
            data: {
                "premise_id": data?.values?.premise_id,
                "poll_title": data?.values?.title,
                "poll_description": data?.values?.description,
                "poll_start_date": data?.values?.start_date && moment(data?.values?.start_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                "poll_end_date": data?.values?.end_date && moment(data?.values?.end_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                "result_allowed": data?.values?.allow_result_visibility,
                "status": data?.values?.status,
                "poll_options": data?.values?.poll_options?.map(opt => ({
                    option_name: opt?.option_name,
                })),
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updatePoll = createAsyncThunk('poll/update', async (data) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + 'poll',
            data: {
                "poll_id": data?.values?.id,
                "premise_id": data?.values?.premise_id,
                "poll_title": data?.values?.title,
                "poll_description": data?.values?.description,
                "poll_start_date": data?.values?.start_date && moment(data?.values?.start_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                "poll_end_date": data?.values?.end_date && moment(data?.values?.end_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                "result_allowed": data?.values?.allow_result_visibility,
                "status": data?.values?.status,
                "poll_options": data?.values?.poll_options?.map(opt => ({
                    id: opt?.id,
                    option_name: opt?.option_name,
                })),
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const delPoll = createAsyncThunk('poll/delete', async (data) => {
    try {
        const res = await axios({
            method: 'DELETE',
            url: getConfig.API_URL + `poll/${data?.id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const poll = createSlice({
    name: 'poll',
    initialState: {
        list: [],
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(pollList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        });

        builder.addCase(pollDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        });
    }
})

export default poll.reducer;